import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import { IE, RU, BE, NL } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import useCoverForProductReturn from 'hooks/media/useCoverForProductReturn'
import { Text } from 'styles/components/typography'

import { SectionWrapperStyled } from './styles'

/**
 * DHowReturn
 *
 * @param {object} props - properties of component
 * @returns {node} DHowReturn
 */
const DHowReturn = props => {
  const { data, index, isSquareHidden } = props
  const {
    locale,
    paths: { cdn_global, cdn },
  } = useContext(LocalizationContext)
  const { colors } = React.useContext(ThemeContext)
  const isRu = locale === RU
  const isEU = [IE, NL, BE].includes(locale)
  const isPng = isRu || isEU
  const coverUrl = useCoverForProductReturn({ locale, cdn, cdn_global })

  const classNameInner = isPng ? 'inner--png' : 'pb-4'

  return (
    <SectionWrapperStyled
      withOverlay={!isPng}
      classNameInner={`inner ${classNameInner}`}
      isPng={isPng}
      coverUrl={coverUrl}
    >
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={isEU ? data[locale].title : data.title}
        index={index}
        squareColor={colors.materialRed}
        lineColor="light"
        textColor="light"
      >
        <div className="row">
          <div className="col-12 col-md-5 col-lg-5 offset-md-1">
            <Text
              className="with-inverted-links"
              dangerouslySetInnerHTML={{
                __html: isEU ? data[locale].content : data.content,
              }}
            />
          </div>
        </div>
      </HowToBlock>
    </SectionWrapperStyled>
  )
}

DHowReturn.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSquareHidden: PropTypes.bool,
}

DHowReturn.defaultProps = {
  isSquareHidden: false,
}

export default DHowReturn
